<template>
  <Page class="detailView">
    <div>
      <div class="pageContent-title">产品信息</div>
      <div class="detailView-with-actions mt-5">
        <a-form class="form flex-form" :form="form" :colon="false">
          <div class="form-base-width">
            <a-form-item label="产品名称" required>
              <a-input
                v-decorator="[
                  'productName',
                  {
                    rules: [{ required: true, message: '请输入产品名称' }],
                  },
                ]"
                :max-length="60"
              ></a-input>
            </a-form-item>
            <a-form-item label="产品国家" required>
              <a-select
                class="form-control"
                v-decorator="['countryId', { rules: [{ required: true, message: '请选择产品国家' }] }]"
                placeholder="请选择类型"
                allowClear
                :options="countryList"
                showSearch
                :filterOption="filterByPY$t"
                @change="changeCountryId"
              ></a-select>
            </a-form-item>
            <a-form-item label="标签" required>
              <a-select
                class="form-control"
                v-decorator="['productType', { rules: [{ required: true, message: '请选择产品国家' }] }]"
                placeholder="请选择类型"
                allowClear
                :options="typesMap.productType"
              ></a-select>
            </a-form-item>
            <a-form-item
              label="入境次数"
              required
              :wrapperCol="{ style: 'width: 100px' }"
              class="float-left"
              style="margin-right: 40px"
            >
              <a-select
                v-decorator="[
                  'entryTimes',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择入境次数',
                      },
                    ],
                  },
                ]"
                :dropdownMatchSelectWidth="false"
                :options="typesMap.entryTimes"
              ></a-select>
            </a-form-item>
            <a-form-item
              label="有效期"
              required
              :wrapperCol="{ style: 'width: 100px' }"
              class="float-left"
              style="margin-right: 40px"
            >
              <a-input
                v-decorator="[
                  'validPeriod',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入有效期',
                      },
                    ],
                  },
                ]"
              ></a-input>
            </a-form-item>
            <a-form-item label="停留时间" required :wrapperCol="{ style: 'width: 100px' }">
              <a-input
                v-decorator="[
                  'stayTime',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入停留时间',
                      },
                    ],
                  },
                ]"
              ></a-input>
            </a-form-item>
            <a-form-item label="办理时长" required>
              <a-input
                placeholder="资料操作1工作日+使馆审核25~35工作日"
                v-decorator="[
                  'processingTime',
                  {
                    rules: [
                      {
                        required: true,
                        max: 28,
                        message: '请填写办理时长，文字不得超过28位',
                      },
                    ],
                  },
                ]"
              ></a-input>
            </a-form-item>
            <a-form-item label="领区" required>
              <a-select
                class="form-control"
                v-decorator="['consularRegionId', { rules: [{ required: true, message: '请选择领区' }] }]"
                placeholder="请选择领区"
                allowClear
                :options="area"
              ></a-select>
            </a-form-item>
            <a-form-item label="成本价格" required>
              <a-input
                v-decorator="[
                  'costPrice',
                  {
                    rules: [
                      {
                        required: true,
                        message: '成本价格不能为空！',
                      },
                      {
                        pattern: Reg.isCurrency,
                        message: '请输入金额格式',
                      },
                    ],
                  },
                ]"
                addon-after="￥"
              ></a-input>
            </a-form-item>

            <a-row>
              <a-col :span="12">
                <a-form-item label="销售价格" required>
                  <a-input
                    v-decorator="[
                      'businessPrice',
                      {
                        rules: [
                          {
                            required: true,
                            message: '销售价格不能为空！',
                          },
                          {
                            pattern: Reg.isCurrency,
                            message: '请输入金额格式',
                          },
                        ],
                      },
                    ]"
                    addon-after="￥"
                    @blur="handleOkBlur"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="直客价格" required>
                  <a-input
                    v-decorator="[
                      'customerPrice',
                      {
                        rules: [
                          {
                            required: true,
                            message: '直客价格不能为空！',
                          },
                          {
                            pattern: Reg.isCurrency,
                            message: '请输入金额格式',
                          },
                        ],
                      },
                    ]"
                    addon-after="￥"
                    @blur="handleOkBlur"
                  ></a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <div v-if="$route.query.productId">
            <a-form-item label="基础资料">
              <AddProductData
                ref="addProductData"
                :productId="$route.query.productId"
              ></AddProductData>
            </a-form-item>
            <a-form-item label="其他所需资料">
              <AddProductDataOther
                ref="addProductDataOther"
                :productId="$route.query.productId"
                @removetypeto="removetypeTo"
                @addtype="addtype"
                @updatetype="updatetype"
                @arriveinit="arriveinit"
              ></AddProductDataOther>
            </a-form-item>
          </div>
          <a-row>
            <a-col :span="24">
              <a-form-item label="产品配图">
                <PictureCardListUpload
                  v-decorator="[
                    'productBanner',
                    {
                      rules: [{ required: true, message: '请上传产品配图' }],
                    },
                  ]"
                  :file-list="form.getFieldValue('productBanner')"
                  :max-count="5"
                  @onremove="onremove"
                  @onchange="updateUrlList"
                ></PictureCardListUpload>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="温馨提示" :wrapperCol="{ style: 'width: 100%' }" required>
            <RichText
              v-decorator="['kindTips', { rules: [{ required: true, message: '请输入温馨提示内容' }] }]"
            ></RichText>
          </a-form-item>
          <a-form-item label="服务内容" :wrapperCol="{ style: 'width: 100%' }" required>
            <RichText
              v-decorator="['serviceContent', { rules: [{ required: true, message: '请输入服务内容' }] }]"
            ></RichText>
          </a-form-item>
          <a-form-item label="办理流程">
            <PictureCardUpload
              v-decorator="['handleProcessUrl', { rules: [{ required: true, message: '请选择办理流程' }] }]"
              :itemWidth="100"
              :itemHeight="250"
            ></PictureCardUpload>
          </a-form-item>
          <a-form-item label="签证示例">
            <PictureCardUpload
              v-decorator="['visaExampleUrl']"
              :itemWidth="200"
              :itemHeight="263"
            ></PictureCardUpload>
          </a-form-item>
        </a-form>
      </div>
      <div class="detailView-actions">
        <a-button class="app-btn" type="default" @click="goBack">返回</a-button>
        <!-- <a-button class="app-btn" type="primary" @click="doSave">保存</a-button> -->
      </div>
    </div>
    <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" @cancel="handleCancel" :width="700">
      <div class="detailView">
        <a-form class="form" :form="modal.form" :colon="false" layout="inline">
          <a-form-item label="资料类型" required>
            <a-input
              v-decorator="['dataType', { rules: [{ required: true, message: '请输入资料类型' }] }]"
              placeholder="请输入资料类型"
            ></a-input>
          </a-form-item>
          <a-form-item label="排序值">
            <a-input
              v-decorator="['sort', { rules: [{ required: true, message: '请输入排序值' }] }]"
              placeholder="数字越大越靠前"
            ></a-input>
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import PictureCardListUpload from '@/components/PictureCardListUpload'
import videoUpload from '@/components/PictureCardListUpload1'
import RichText from '@/components/RichText'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import { getAreaList, getCountryList } from '@/service/getData'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import Reg from '@/utils/reg'
import AddProductData from './modules/AddProductData'
import AddProductDataOther from './modules/AddProductDataOther'
import ArriveEmbassy from './modules/ArriveEmbassy'

export default {
  components: {
    Page,
    PictureCardUpload,
    PictureCardListUpload,
    videoUpload,
    AddProductData,
    AddProductDataOther,
    ArriveEmbassy,
    RichText,
  },
  props: {},
  mixins: [toolMixin, queryViewMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '10%',
        align: 'center',
        customRender: (text, row, index) => {
          return <div>{index + 1}</div>
        },
      },
      {
        title: '类型',
        width: '40%',
        align: 'center',
        dataIndex: 'dataType',
      },
      {
        title: '排序',
        width: '12%',
        align: 'center',
        dataIndex: 'sort',
      },
      {
        title: '操作',
        width: '30%',
        align: 'center',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-10 justify-center items-center">
              <a
                onClick={() => {
                  this.setDataType(row)
                }}
              >
                配置
              </a>
              <a
                onClick={() => {
                  this.editRow(row)
                }}
              >
                <app-icon type="icon-bianji"></app-icon>
              </a>
              <a
                onClick={() => {
                  this.removeRow(row)
                }}
              >
                <app-icon type="icon-shanchu"></app-icon>
              </a>
            </div>
          )
        },
      },
    ]
    return {
      // channelProductPriceReqDtoList: [],
      // addChannelForm: this.$form.createForm(this),
      // addChannelVisible: false,
      richForm: {
        serviceContent: '',
        warmHint: '',
      },
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      form: this.$form.createForm(this),
      tableColumns: tableColumns,
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '添加身份类型',
        data: {},
      },
      countryList: [],
      area: [],
      Reg,
      priceDisabled: true,
      minPrice: null,

      costDataSource: [
        {
          costName: '',
          costPrice: '',
          isFixed: false,
        },
      ],
    }
  },
  async mounted() {
    this.countryList = await getCountryList()
    const id = this.$route.query.productId
    if (id) {
      this.initFormById(id)
    }
  },
  computed: {
    typesMap() {
      return {
        productType: [
          {
            value: '1',
            label: '旅游签证',
          },
          {
            value: '2',
            label: '商务签证',
          },
          {
            value: '3',
            label: '探亲签证',
          },
          {
            value: '4',
            label: '留学签证',
          },
          {
            value: '5',
            label: '移民签证',
          },
          {
            value: '6',
            label: '其他',
          },
        ],
        entryTimes: [
          {
            value: '0',
            label: '使馆批',
          },
          {
            value: '1',
            label: '1次',
          },
          {
            value: '2',
            label: '多次',
          },
        ],
      }
    },
  },
  methods: {
    handleAddCostList() {
      this.costDataSource = [...this.costDataSource, { costName: '', costPrice: '', isFixed: false }]
    },
    handleDelCost(index) {
      this.costDataSource.splice(index, 1)
    },
    handleOkBlur() {
      const price = this.form.getFieldValue('costPrice')
      if (this.form.getFieldValue('sellingPrice') < price) {
        this.$message.warning(`价格不能低于${price}`)
      }
    },

    arriveinit() {
      this.$refs.arriveEmbassy.init()
    },
    removetypeTo(index) {
      this.$refs.arriveEmbassy.removetypeTo(index)
    },
    addtype(obj) {
      this.$refs.arriveEmbassy.addtype(obj)
    },
    updatetype(obj) {
      this.$refs.arriveEmbassy.updatetype(obj)
    },
    updateVisaType(e) {
      if (this.$route.query.productId) {
        this.$refs.addProductData.updateVisaType(e.target.value)
        this.$refs.addProductDataOther.updateVisaType(e.target.value)
      }
      // if (e.target.value === 1) {
      //   this.form.setFieldsValue({
      //     isAudit: 0,
      //   })
      // }
    },
    updateUrlList(obj) {
      if (!this.form.getFieldValue('productBanner') || this.form.getFieldValue('productBanner').length <= 0) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            productBanner: [obj],
          })
        })
      } else {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            productBanner: [...this.form.getFieldValue('productBanner'), ...[obj]],
          })
        })
      }
    },
    videoChange(obj) {
      this.form.setFieldsValue({
        video: [obj],
      })
      this.$refs.video.upLoading()
    },
    dataVideoChange(obj) {
      this.form.setFieldsValue({
        dataVideo: [obj],
      })
      this.$refs.video.upLoading()
    },
    videoChangeImage(obj, type) {
      this.form.setFieldsValue({
        [type]: [obj],
      })
    },
    onremove1() {
      this.form.setFieldsValue({
        video: [],
      })
    },
    onremove2() {
      this.form.setFieldsValue({
        dataVideo: [],
      })
    },
    onremoveImage(type) {
      this.form.setFieldsValue({
        [type]: [],
      })
    },

    onremove(index) {
      const list = JSON.parse(JSON.stringify(this.form.getFieldValue('productBanner')))
      list.splice(index, 1)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          productBanner: list,
        })
      })
    },
    setDataType(row) {
      this.$router.push({
        path: '/m/scopeMain/transferProduct/setDataType',
        query: {
          data: JSON.stringify(row),
        },
      })
    },
    // channelRemoveRow(row, index) {
    //   console.log('row', index)
    //   this.channelProductPriceReqDtoList.splice(index, 1)
    // },
    // changePrice(row, index) {
    //   this.channelProductPriceReqDtoList[index].changePrice = row.changePrice
    // },
    async removeRow(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.post('/visa/admin/productMaterial/deleteByMaterialTypeId', {
        data: {
          materialTypeId: row.materialTypeId,
        },
      })
      this.$message.success('操作成功!')
      this.initFormById(row.productId)
    },
    doSave() {
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          console.log('productBanner', params)
          if (!params.auditUserId) {
            params.auditUserId = ''
          }
          params.isAudit = 0
          try {
            const productId = this.$route.query.productId
            const list = [
              {
                introductionType: 1,
                materialType: 1,
                materialSort: 0,
                materialImgUrl: params.videoUrl && params.videoUrl.length > 0 ? params.videoUrl[0] : '',
                materialUrl: params.video && params.video.length > 0 ? params.video[0] : '',
              },
              {
                introductionType: 2,
                materialType: 1,
                materialSort: 1,
                materialImgUrl: params.dataVideoUrl && params.dataVideoUrl.length > 0 ? params.dataVideoUrl[0] : '',
                materialUrl: params.materialUrl && params.materialUrl.length > 0 ? params.materialUrl[0] : '',
              },
            ]
            params.productBanner.reverse().forEach((e, index) => {
              list.push({
                introductionType: 3,
                materialType: 2,
                materialSort: index + 2,
                materialImgUrl: '',
                materialUrl: e,
              })
            })

            const data = {
              ...params,
              introductionMaterialList: list,
              countryName: this.countryList.find(item => item.value === params.countryId)?.label,
              area: this.area.find(item => item.value === params.consularRegionId)?.label,
              // channelProductPriceReqDtoList: this.channelProductPriceReqDtoList,
              costList: this.costDataSource,
            }
            // 编辑的参数
            if (productId && !this.$route.query.copyId) {
              data.productId = productId
            }
            // 编辑逻辑 复制不能传productId 因为传了会被判定为是编辑
            if (productId && !this.$route.query.copyId) {
              const list1 = this.$refs.addProductData.getList()
              const list2 = this.$refs.addProductDataOther.getList()
              const list3 = this.$refs.arriveEmbassy.getList()
              if (list1.length === 0 && list2.length === 0) {
                return this.$message.error('请添加基础资料或必备资料')
              }
              await this.$axios.post('/visa/admin/productMaterial/saveMaterialList', {
                data: [...list1, ...list2, ...list3],
              })
              await this.$axios.post('/visa/admin/productTransfer/save', { data })
              this.$message.success('操作成功!')
              this.$router.replace({
                path: '/m/scopeMain/transferProduct/transferProduct',
                query: {
                  pageNumber: this.$route.query.pageNumber,
                  productName: this.$route.query.productName,
                  countryId: this.$route.query.countryId,
                  channelId: this.$route.query.channelId,
                },
              })
              // 复制逻辑
            } else if (productId && this.$route.query.copyId) {
              const list1 = this.$refs.addProductData.getList()
              const list2 = this.$refs.addProductDataOther.getList()
              const list3 = this.$refs.arriveEmbassy.getList()
              if (list1.length === 0 && list2.length === 0) {
                return this.$message.error('请添加基础资料或必备资料')
              }
              let res = await this.$axios.post('/visa/admin/productTransfer/save', { data })
              if (res.success) {
                let arr = [...list1, ...list2, ...list3]
                for (let i = 0; i < arr.length; i++) {
                  arr[i].productId = res.data
                }
                await this.$axios.post('/visa/admin/productMaterial/saveMaterialList', {
                  data: arr,
                })
                // 复制供应商
                await this.$axios.post('product-web-api/admin/productTransefer/setSupplier', {
                  data: {
                    productId: res.data,
                    supplierCompanyId: this.$route.query.supplierCompanyId,
                    supplierCompanyName: this.$route.query.supplierCompanyName,
                  },
                })
                this.$message.success('操作成功!')
                this.$router.replace({
                  path: '/m/scopeMain/transferProduct/transferProduct',
                  query: {
                    pageNumber: this.$route.query.pageNumber,
                    productName: this.$route.query.productName,
                    countryId: this.$route.query.countryId,
                    channelId: this.$route.query.channelId,
                  },
                })
              }
            } else {
              // 新增逻辑
              const res = await this.$axios.post('/visa/admin/productTransfer/save', { data })
              this.$message.success('操作成功!')
              this.$router.replace({
                query: {
                  productId: res.data,
                  pageNumber: this.$route.query.pageNumber,
                  productName: this.$route.query.productName,
                  countryId: this.$route.query.countryId,
                  channelId: this.$route.query.channelId,
                },
              })
            }
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    goBack() {
      this.$router.replace({
        path: '/m/scopeMain/transferProduct/transferProduct',
        query: {
          pageNumber: this.$route.query.pageNumber,
          productName: this.$route.query.productName,
          countryId: this.$route.query.countryId,
          channelId: this.$route.query.channelId,
        },
      })
    },
    addRow() {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.title = '添加身份类型'
    },
    editRow(row) {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.title = '修改资料'
      this.safeSetFieldsValue$t(this.modal.form, { ...row })
      this.modal.data = { ...row }
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            await this.$axios.post('/visa/admin/productMaterial/saveMaterialType', {
              data: {
                productId: this.$route.query.productId,
                materialTypeId: this.modal.data.materialTypeId,
                ...params,
              },
            })
            this.initFormById(this.$route.query.productId)
            this.$message.success('操作成功!')
            this.modal.visible = false
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    handleCancel() {
      this.modal.visible = false
    },
    async initFormById(id) {
      const { data, success } = await this.$axios.get(`/visa/admin/product/${id}`)
      if (success) {
        const descriptionRes = await this.$axios.get(`/visa/admin/product/${id}/description`)
        let description = null
        if (descriptionRes.data && descriptionRes.data.length > 0) {
          description = descriptionRes.data.filter((item) => item.descriptionType === 3)
        }
        if (description) {
          data.productBanner = description.map((item) => item.materialUrl)
        }
        console.log('dataById', data);

        this.safeSetFieldsValue$t(this.form, { ...data })
      }
      this.area = await getAreaList(data.countryId)
    },
    async changeCountryId(value) {
      if (value) {
        this.area = await getAreaList(value)
        this.form.setFieldsValue({
          consularRegionId: '',
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
// .ant-tag {
//   font-size: 16px;
//   line-height: 28px;
// }
.modal-form {
  ::v-deep .ant-form-item {
    width: 100%;
    margin-bottom: 24px;
  }
}
</style>
